/*using-scripts-in-packagejson*/
/*using-global-turbo*/
/*automatic-package-scoping*/
/*customizing-behavior*/
/*running-multiple-tasks*/
/*using-filters*/
/*filtering-by-package*/
/*filtering-by-directory*/
/*filtering-to-include-dependents*/
/*filtering-to-include-dependencies*/
/*filtering-by-source-control-changes*/
/*combining-filters*/
/*next-steps*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "正在运行任务",
  "description": "学习如何通过 `turbo` CLI 在仓库中运行任务。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 通过自动并行化和缓存任务来优化存储库中的开发者工作流程。将任务配置为 在 turbo.json 中注册 后，你将拥有一个强大的新工具集，用于运行存储库中的脚本："
  }, {
    "heading": "",
    "content": "¥Turborepo optimizes the developer workflows in your repository by automatically parallelizing and caching tasks. Once a task is registered in turbo.json, you have a powerful new toolset for running the scripts in your repository:"
  }, {
    "heading": "",
    "content": "在 package.json 中使用 scripts 执行需要经常运行的任务"
  }, {
    "heading": "",
    "content": "¥Use scripts in package.json for tasks you need to run often"
  }, {
    "heading": "",
    "content": "使用全局 turbo 快速按需运行自定义任务"
  }, {
    "heading": "",
    "content": "¥Use global turbo to quickly run custom tasks on-demand"
  }, {
    "heading": "",
    "content": "按目录、包名称、源代码控制更改等过滤任务"
  }, {
    "heading": "",
    "content": "¥Filter tasks by directories, package names, source control changes, and more"
  }, {
    "heading": "",
    "content": "通过 turbo 运行任务非常强大，因为你可以获得一个模型，用于在开发和 CI 流水线中执行整个存储库的工作流。"
  }, {
    "heading": "",
    "content": "¥Running tasks through turbo is powerful because you get one model for executing workflows throughout your repository in development and in your CI pipelines."
  }, {
    "heading": "在-packagejson-中使用-scripts-using-scripts-in-packagejson",
    "content": "¥Using scripts in package.json"
  }, {
    "heading": "在-packagejson-中使用-scripts-using-scripts-in-packagejson",
    "content": "对于你经常运行的任务，你可以将 turbo 命令直接写入根 package.json。"
  }, {
    "heading": "在-packagejson-中使用-scripts-using-scripts-in-packagejson",
    "content": "¥For tasks that you run frequently, you can write your turbo commands directly into your root package.json."
  }, {
    "heading": "在-packagejson-中使用-scripts-using-scripts-in-packagejson",
    "content": "turbo 是 turbo run 的别名 - 但我们建议在 package.json 和 CI 工作流中使用 turbo run，以避免与将来可能添加的 turbo 子命令发生潜在冲突。"
  }, {
    "heading": "在-packagejson-中使用-scripts-using-scripts-in-packagejson",
    "content": "¥turbo is an alias for turbo run - but we recommend using turbo run in\npackage.json and CI workflows to avoid potential collisions with possible\nturbo subcommands that could be added in the future."
  }, {
    "heading": "在-packagejson-中使用-scripts-using-scripts-in-packagejson",
    "content": "然后可以使用你的包管理器运行这些脚本。"
  }, {
    "heading": "在-packagejson-中使用-scripts-using-scripts-in-packagejson",
    "content": "¥These scripts can then be run using your package manager."
  }, {
    "heading": "在-packagejson-中使用-scripts-using-scripts-in-packagejson",
    "content": "你只需在根 package.json 中编写 turbo 命令。将 turbo 命令写入包的 package.json 可能会导致递归调用 turbo。"
  }, {
    "heading": "在-packagejson-中使用-scripts-using-scripts-in-packagejson",
    "content": "¥You only want to write turbo commands in your root package.json. Writing turbo commands into the package.json of packages can lead to recursively\ncalling turbo."
  }, {
    "heading": "使用全局-turbo-using-global-turbo",
    "content": "¥Using global turbo"
  }, {
    "heading": "使用全局-turbo-using-global-turbo",
    "content": "全局安装 turbo 允许你直接从终端运行命令。这可以改善你的本地开发体验，因为它可以让你在需要时更轻松地运行所需的内容。"
  }, {
    "heading": "使用全局-turbo-using-global-turbo",
    "content": "¥Installing turbo globally lets you run commands directly from your terminal. This improves your local development experience since it makes it easier to run exactly what you need, when you need it."
  }, {
    "heading": "使用全局-turbo-using-global-turbo",
    "content": "此外，全局 turbo 在你的 CI 流水线中非常有用，它可以让你最大限度地控制在流水线的每个点上要运行哪些任务。"
  }, {
    "heading": "使用全局-turbo-using-global-turbo",
    "content": "¥Additionally, global turbo is useful in your CI pipelines, giving you maximum control of exactly which tasks to run at each point in your pipeline."
  }, {
    "heading": "自动确定软件包作用域-automatic-package-scoping",
    "content": "¥Automatic Package Scoping"
  }, {
    "heading": "自动确定软件包作用域-automatic-package-scoping",
    "content": "当你在某个包的目录中时，turbo 会自动将命令范围限定在该包的 软件包图表 上。这意味着你可以快速编写命令，而无需对包进行 编写过滤器。"
  }, {
    "heading": "自动确定软件包作用域-automatic-package-scoping",
    "content": "¥When you're in a package's directory, turbo will automatically scope commands to the Package Graph for that package. This means you can quickly write commands without having to write filters for the package."
  }, {
    "heading": "自动确定软件包作用域-automatic-package-scoping",
    "content": "在上面的示例中，turbo build 命令将使用在 turbo.json 中注册的 build 任务为 docs 包运行 build 任务。"
  }, {
    "heading": "自动确定软件包作用域-automatic-package-scoping",
    "content": "¥In the example above, the turbo build command will run the build task for the docs package using the build task registered in turbo.json."
  }, {
    "heading": "自动确定软件包作用域-automatic-package-scoping",
    "content": "使用过滤器 将覆盖自动包作用域。"
  }, {
    "heading": "自动确定软件包作用域-automatic-package-scoping",
    "content": "¥Using a filter will override Automatic Package Scoping."
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "¥Customizing behavior"
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "在 run 子命令文档 中，你会发现许多有用的标志，可以根据你的需要定制 turbo run 的行为。运行全局 turbo 时，你可以使用以下工作流程加快速度："
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "¥In the documentation for the run subcommand, you'll find many useful flags to tailor the behavior of turbo run for what you need. When running global turbo, you can go faster using workflows like:"
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "最常用命令的变体：package.json 中的 build 脚本在 turbo build 中最为实用。 - 但你目前可能只对特定的软件包感兴趣。你可以使用 turbo build --filter=@repo/ui 快速筛选你感兴趣的特定包。"
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "¥Variations of your most common commands: The build script in package.json has the most utility when it is turbo build - but you might only be interested in a specific package at the moment. You can quickly filter for the specific package you're interested in using turbo build --filter=@repo/ui."
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "一次性命令：像 turbo build --dry 这样的命令并不常用，因此你可能不会在 package.json 中为其创建脚本。相反，你可以在需要时直接在终端中运行它。"
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "¥One-off commands: Commands like turbo build --dry aren't needed often so you likely won't create a script in your package.json for it. Instead, you can run it directly in your terminal whenever you need it."
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "覆盖 turbo.json 配置：某些 CLI 参数在 turbo.json 中有等效项，你可以覆盖它们。例如，你可能已将 turbo build 命令配置为使用 turbo.json 中的 \"outputLogs\": \"full\"。 - 但你目前只想查看错误。使用全局 turbo，你可以使用 turbo lint --output-logs=errors-only 仅显示错误。"
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "¥Overriding turbo.json configuration: Some CLI flags have an equivalent in turbo.json that you can override. For instance, you may have a turbo build command configured to use \"outputLogs\": \"full\" in turbo.json - but you're only interested in seeing errors at the moment. Using global turbo, you can use turbo lint --output-logs=errors-only to only show errors."
  }, {
    "heading": "运行多个任务-running-multiple-tasks",
    "content": "¥Running multiple tasks"
  }, {
    "heading": "运行多个任务-running-multiple-tasks",
    "content": "turbo 能够运行多个任务，并尽可能并行执行。"
  }, {
    "heading": "运行多个任务-running-multiple-tasks",
    "content": "¥turbo is able to run multiple tasks, parallelizing whenever possible."
  }, {
    "heading": "运行多个任务-running-multiple-tasks",
    "content": "此命令将运行所有任务，并根据你的任务定义自动检测可以尽早运行脚本的位置。"
  }, {
    "heading": "运行多个任务-running-multiple-tasks",
    "content": "¥This command will run all of the tasks, automatically detecting where it can run a script as early as possible, according to your task definitions."
  }, {
    "heading": "运行多个任务-running-multiple-tasks",
    "content": "turbo test lint 将运行与 turbo lint test 完全相同的任务。"
  }, {
    "heading": "运行多个任务-running-multiple-tasks",
    "content": "¥turbo test lint will run tasks exactly the same as turbo lint test."
  }, {
    "heading": "运行多个任务-running-multiple-tasks",
    "content": "如果你想确保一个任务会阻止另一个任务的执行，请在你的 任务配置 中表达这种关系。"
  }, {
    "heading": "运行多个任务-running-multiple-tasks",
    "content": "¥If you want to ensure that one task blocks the execution of another, express that relationship in your task configurations."
  }, {
    "heading": "使用过滤器-using-filters",
    "content": "¥Using filters"
  }, {
    "heading": "使用过滤器-using-filters",
    "content": "caching 确保你不会重复执行相同的工作，从而保持快速运行，你还可以过滤任务以仅运行 任务图 的子集。"
  }, {
    "heading": "使用过滤器-using-filters",
    "content": "¥While caching ensures you stay fast by never doing the same work twice, you can also filter tasks to run only a subset of the Task Graph."
  }, {
    "heading": "使用过滤器-using-filters",
    "content": "--filter API 参考 中有很多用于过滤的高级用例，但下面讨论的是最常见的用例。"
  }, {
    "heading": "使用过滤器-using-filters",
    "content": "¥There are many advanced use cases for filtering in the --filter API reference but the most common use cases are discussed below."
  }, {
    "heading": "按软件包过滤-filtering-by-package",
    "content": "¥Filtering by package"
  }, {
    "heading": "按软件包过滤-filtering-by-package",
    "content": "按包过滤是一种简单的方法，可以仅针对你当前正在处理的包运行任务。"
  }, {
    "heading": "按软件包过滤-filtering-by-package",
    "content": "¥Filtering by package is a simple way to only run tasks for the packages you're currently working on."
  }, {
    "heading": "按软件包过滤-filtering-by-package",
    "content": "你也可以直接在 CLI 命令中筛选包的特定任务，而无需使用 --filter："
  }, {
    "heading": "按软件包过滤-filtering-by-package",
    "content": "¥You can also filter to a specific task for the package directly in your CLI command without needing to use --filter:"
  }, {
    "heading": "按目录过滤-filtering-by-directory",
    "content": "¥Filtering by directory"
  }, {
    "heading": "按目录过滤-filtering-by-directory",
    "content": "你的代码库可能具有一个目录结构，其中相关的包被分组在一起。在这种情况下，你可以捕获该目录的全局变量，以便将 turbo 集中在这些包上。"
  }, {
    "heading": "按目录过滤-filtering-by-directory",
    "content": "¥Your repository might have a directory structure where related packages are grouped together. In this case, you can capture the glob for that directory to focus turbo on those packages."
  }, {
    "heading": "过滤以包含依赖-filtering-to-include-dependents",
    "content": "¥Filtering to include dependents"
  }, {
    "heading": "过滤以包含依赖-filtering-to-include-dependents",
    "content": "当你处理特定包时，你可能需要为该包及其依赖运行任务。当你更改包并希望确保更改不会破坏其任何依赖时，... 微语法非常有用。"
  }, {
    "heading": "过滤以包含依赖-filtering-to-include-dependents",
    "content": "¥When you're working on a specific package, you might want to run tasks for the package and its dependents. The ... microsyntax is useful when you're making changes to a package and want to ensure that the changes don't break any of its dependents."
  }, {
    "heading": "过滤以包含依赖-filtering-to-include-dependencies",
    "content": "¥Filtering to include dependencies"
  }, {
    "heading": "过滤以包含依赖-filtering-to-include-dependencies",
    "content": "要将范围限制在某个包及其依赖，请在包名称后附加 ...。这会为指定的包及其依赖的所有包运行任务。"
  }, {
    "heading": "过滤以包含依赖-filtering-to-include-dependencies",
    "content": "¥To limit the scope to a package and its dependencies, append ... to the package name. This runs the task for the specified package and all packages it depends on."
  }, {
    "heading": "按源代码控制更改过滤-filtering-by-source-control-changes",
    "content": "¥Filtering by source control changes"
  }, {
    "heading": "按源代码控制更改过滤-filtering-by-source-control-changes",
    "content": "使用过滤器根据源代码控制中的更改运行任务，是仅针对受更改影响的包运行任务的好方法。源代码控制过滤器必须封装在 [] 中。"
  }, {
    "heading": "按源代码控制更改过滤-filtering-by-source-control-changes",
    "content": "¥Using filters to run tasks based on changes in source control is a great way to run tasks only for the packages that are affected by your changes. Source control filters must be wrapped in []."
  }, {
    "heading": "按源代码控制更改过滤-filtering-by-source-control-changes",
    "content": "与上一个提交比较：turbo build --filter=[HEAD^1]"
  }, {
    "heading": "按源代码控制更改过滤-filtering-by-source-control-changes",
    "content": "¥Comparing to the previous commit: turbo build --filter=[HEAD^1]"
  }, {
    "heading": "按源代码控制更改过滤-filtering-by-source-control-changes",
    "content": "与主分支比较：turbo build --filter=[main...my-feature]"
  }, {
    "heading": "按源代码控制更改过滤-filtering-by-source-control-changes",
    "content": "¥Comparing to the main branch: turbo build --filter=[main...my-feature]"
  }, {
    "heading": "按源代码控制更改过滤-filtering-by-source-control-changes",
    "content": "使用 SHA 比较特定提交：turbo build --filter=[a1b2c3d...e4f5g6h]"
  }, {
    "heading": "按源代码控制更改过滤-filtering-by-source-control-changes",
    "content": "¥Comparing specific commits using SHAs: turbo build --filter=[a1b2c3d...e4f5g6h]"
  }, {
    "heading": "按源代码控制更改过滤-filtering-by-source-control-changes",
    "content": "使用分支名称比较特定提交：turbo build --filter=[your-feature...my-feature]"
  }, {
    "heading": "按源代码控制更改过滤-filtering-by-source-control-changes",
    "content": "¥Comparing specific commits using branch names: turbo build --filter=[your-feature...my-feature]"
  }, {
    "heading": "按源代码控制更改过滤-filtering-by-source-control-changes",
    "content": "通常，你可以依靠缓存来保持代码库的快速运行。当你使用 远程缓存 时，你可以依靠未更改的包的缓存命中。"
  }, {
    "heading": "按源代码控制更改过滤-filtering-by-source-control-changes",
    "content": "¥In general, you can rely on caching to keep your repository fast. When you're\nusing Remote Caching, you can count on\nhitting cache for unchanged packages."
  }, {
    "heading": "合并过滤器-combining-filters",
    "content": "¥Combining filters"
  }, {
    "heading": "合并过滤器-combining-filters",
    "content": "为了更加明确，你可以组合使用过滤器来进一步优化 任务图 的入口点。"
  }, {
    "heading": "合并过滤器-combining-filters",
    "content": "¥For even more specificity, you can combine filters to further refine the entrypoints into your Task Graph."
  }, {
    "heading": "合并过滤器-combining-filters",
    "content": "多个过滤器组合成一个联合体，这意味着 任务图 将包含与任意过滤器匹配的任务。更多有关过滤器高级用法的信息，请参阅 --filter API 参考。"
  }, {
    "heading": "合并过滤器-combining-filters",
    "content": "¥Multiple filters are combined as a union, meaning that the Task Graph will include tasks that match any of the filters. For more information on advanced usage of filters, see the --filter API reference."
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥Next steps"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "当你开始在代码库中运行任务时，你可能会注意到任务速度变快了。接下来，你将探索 caching 以及 turbo 如何让你避免重复工作。"
  }, {
    "heading": "后续步骤-next-steps",
    "content": "¥When you start running tasks in your repository, you might start noticing that your tasks get faster. Next, you'll explore caching and how turbo makes it so you never do the same work twice."
  }],
  "headings": [{
    "id": "在-packagejson-中使用-scripts-using-scripts-in-packagejson",
    "content": "在 package.json 中使用 scripts /*using-scripts-in-packagejson*/"
  }, {
    "id": "使用全局-turbo-using-global-turbo",
    "content": "使用全局 turbo /*using-global-turbo*/"
  }, {
    "id": "自动确定软件包作用域-automatic-package-scoping",
    "content": "自动确定软件包作用域 /*automatic-package-scoping*/"
  }, {
    "id": "自定义行为-customizing-behavior",
    "content": "自定义行为 /*customizing-behavior*/"
  }, {
    "id": "运行多个任务-running-multiple-tasks",
    "content": "运行多个任务 /*running-multiple-tasks*/"
  }, {
    "id": "使用过滤器-using-filters",
    "content": "使用过滤器 /*using-filters*/"
  }, {
    "id": "按软件包过滤-filtering-by-package",
    "content": "按软件包过滤 /*filtering-by-package*/"
  }, {
    "id": "按目录过滤-filtering-by-directory",
    "content": "按目录过滤 /*filtering-by-directory*/"
  }, {
    "id": "过滤以包含依赖-filtering-to-include-dependents",
    "content": "过滤以包含依赖 /*filtering-to-include-dependents*/"
  }, {
    "id": "过滤以包含依赖-filtering-to-include-dependencies",
    "content": "过滤以包含依赖 /*filtering-to-include-dependencies*/"
  }, {
    "id": "按源代码控制更改过滤-filtering-by-source-control-changes",
    "content": "按源代码控制更改过滤 /*filtering-by-source-control-changes*/"
  }, {
    "id": "合并过滤器-combining-filters",
    "content": "合并过滤器 /*combining-filters*/"
  }, {
    "id": "后续步骤-next-steps",
    "content": "后续步骤 /*next-steps*/"
  }]
};
import {Callout} from '#components/callout';
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {LinkToDocumentation} from '#components/link-to-documentation';
import {InVersion} from '#components/in-version';
export const toc = [{
  depth: 2,
  url: "#在-packagejson-中使用-scripts-using-scripts-in-packagejson",
  title: _jsxs(_Fragment, {
    children: ["在 ", _jsx("code", {
      children: "package.json"
    }), " 中使用 ", _jsx("code", {
      children: "scripts"
    }), " "]
  })
}, {
  depth: 2,
  url: "#使用全局-turbo-using-global-turbo",
  title: _jsxs(_Fragment, {
    children: ["使用全局 ", _jsx("code", {
      children: "turbo"
    }), " "]
  })
}, {
  depth: 3,
  url: "#自动确定软件包作用域-automatic-package-scoping",
  title: _jsx(_Fragment, {
    children: "自动确定软件包作用域 "
  })
}, {
  depth: 3,
  url: "#自定义行为-customizing-behavior",
  title: _jsx(_Fragment, {
    children: "自定义行为 "
  })
}, {
  depth: 2,
  url: "#运行多个任务-running-multiple-tasks",
  title: _jsx(_Fragment, {
    children: "运行多个任务 "
  })
}, {
  depth: 2,
  url: "#使用过滤器-using-filters",
  title: _jsx(_Fragment, {
    children: "使用过滤器 "
  })
}, {
  depth: 3,
  url: "#按软件包过滤-filtering-by-package",
  title: _jsx(_Fragment, {
    children: "按软件包过滤 "
  })
}, {
  depth: 3,
  url: "#按目录过滤-filtering-by-directory",
  title: _jsx(_Fragment, {
    children: "按目录过滤 "
  })
}, {
  depth: 3,
  url: "#过滤以包含依赖-filtering-to-include-dependents",
  title: _jsx(_Fragment, {
    children: "过滤以包含依赖 "
  })
}, {
  depth: 3,
  url: "#过滤以包含依赖-filtering-to-include-dependencies",
  title: _jsx(_Fragment, {
    children: "过滤以包含依赖 "
  })
}, {
  depth: 3,
  url: "#按源代码控制更改过滤-filtering-by-source-control-changes",
  title: _jsx(_Fragment, {
    children: "按源代码控制更改过滤 "
  })
}, {
  depth: 3,
  url: "#合并过滤器-combining-filters",
  title: _jsx(_Fragment, {
    children: "合并过滤器 "
  })
}, {
  depth: 2,
  url: "#后续步骤-next-steps",
  title: _jsx(_Fragment, {
    children: "后续步骤 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo 通过自动并行化和缓存任务来优化存储库中的开发者工作流程。将任务配置为 ", _jsxs(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks",
        children: ["在 ", _jsx(_components.code, {
          children: "turbo.json"
        }), " 中注册"]
      }), " 后，你将拥有一个强大的新工具集，用于运行存储库中的脚本："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo optimizes the developer workflows in your repository by automatically parallelizing and caching tasks. Once a task is ", _jsxs(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks",
        children: ["registered in ", _jsx(_components.code, {
          children: "turbo.json"
        })]
      }), ", you have a powerful new toolset for running the scripts in your repository:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsxs(_components.a, {
            href: "#using-scripts-in-packagejson",
            children: ["在 ", _jsx(_components.code, {
              children: "package.json"
            }), " 中使用 ", _jsx(_components.code, {
              children: "scripts"
            }), " 执行需要经常运行的任务"]
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.a, {
            href: "#using-scripts-in-packagejson",
            children: ["Use ", _jsx(_components.code, {
              children: "scripts"
            }), " in ", _jsx(_components.code, {
              children: "package.json"
            }), " for tasks you need to run often"]
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsxs(_components.a, {
            href: "#using-global-turbo",
            children: ["使用全局 ", _jsx(_components.code, {
              children: "turbo"
            }), " 快速按需运行自定义任务"]
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.a, {
            href: "#using-global-turbo",
            children: ["Use global ", _jsx(_components.code, {
              children: "turbo"
            }), " to quickly run custom tasks on-demand"]
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#using-filters",
            children: "按目录、包名称、源代码控制更改等过滤任务"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#using-filters",
            children: "Filter tasks by directories, package names, source control changes, and more"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["通过 ", _jsx(_components.code, {
        children: "turbo"
      }), " 运行任务非常强大，因为你可以获得一个模型，用于在开发和 CI 流水线中执行整个存储库的工作流。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Running tasks through ", _jsx(_components.code, {
        children: "turbo"
      }), " is powerful because you get one model for executing workflows throughout your repository in development and in your CI pipelines."]
    }), "\n", _jsxs(_components.h2, {
      id: "在-packagejson-中使用-scripts-using-scripts-in-packagejson",
      children: ["在 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中使用 ", _jsx(_components.code, {
        children: "scripts"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Using ", _jsx(_components.code, {
        children: "scripts"
      }), " in ", _jsx(_components.code, {
        children: "package.json"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["对于你经常运行的任务，你可以将 ", _jsx(_components.code, {
        children: "turbo"
      }), " 命令直接写入根 ", _jsx(_components.code, {
        children: "package.json"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For tasks that you run frequently, you can write your ", _jsx(_components.code, {
        children: "turbo"
      }), " commands directly into your root ", _jsx(_components.code, {
        children: "package.json"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run lint\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "turbo"
        }), " 是 ", _jsx(_components.code, {
          children: "turbo run"
        }), " 的别名 - 但我们建议在 ", _jsx(_components.code, {
          children: "package.json"
        }), " 和 CI 工作流中使用 ", _jsx(_components.code, {
          children: "turbo run"
        }), "，以避免与将来可能添加的 ", _jsx(_components.code, {
          children: "turbo"
        }), " 子命令发生潜在冲突。"]
      }), _jsxs(_components.p, {
        children: ["¥", _jsx(_components.code, {
          children: "turbo"
        }), " is an alias for ", _jsx(_components.code, {
          children: "turbo run"
        }), " - but we recommend using ", _jsx(_components.code, {
          children: "turbo run"
        }), " in\n", _jsx(_components.code, {
          children: "package.json"
        }), " and CI workflows to avoid potential collisions with possible\n", _jsx(_components.code, {
          children: "turbo"
        }), " subcommands that could be added in the future."]
      })]
    }), "\n", _jsx(_components.p, {
      children: "然后可以使用你的包管理器运行这些脚本。"
    }), "\n", _jsx(_components.p, {
      children: "¥These scripts can then be run using your package manager."
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dev"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dev"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " run"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dev"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bun"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " run"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dev"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsxs(Callout, {
      type: "warn",
      children: [_jsxs(_components.p, {
        children: ["你只需在根 ", _jsx(_components.code, {
          children: "package.json"
        }), " 中编写 ", _jsx(_components.code, {
          children: "turbo"
        }), " 命令。将 ", _jsx(_components.code, {
          children: "turbo"
        }), " 命令写入包的 ", _jsx(_components.code, {
          children: "package.json"
        }), " 可能会导致递归调用 ", _jsx(_components.code, {
          children: "turbo"
        }), "。"]
      }), _jsxs(_components.p, {
        children: ["¥You only want to write ", _jsx(_components.code, {
          children: "turbo"
        }), " commands in your root ", _jsx(_components.code, {
          children: "package.json"
        }), ". Writing ", _jsx(_components.code, {
          children: "turbo"
        }), " commands into the ", _jsx(_components.code, {
          children: "package.json"
        }), " of packages can lead to recursively\ncalling ", _jsx(_components.code, {
          children: "turbo"
        }), "."]
      })]
    }), "\n", _jsxs(_components.h2, {
      id: "使用全局-turbo-using-global-turbo",
      children: ["使用全局 ", _jsx(_components.code, {
        children: "turbo"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Using global ", _jsx(_components.code, {
        children: "turbo"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/getting-started/installation#global-installation",
        children: ["全局安装 ", _jsx(_components.code, {
          children: "turbo"
        })]
      }), " 允许你直接从终端运行命令。这可以改善你的本地开发体验，因为它可以让你在需要时更轻松地运行所需的内容。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsxs(_components.a, {
        href: "/docs/getting-started/installation#global-installation",
        children: ["Installing ", _jsx(_components.code, {
          children: "turbo"
        }), " globally"]
      }), " lets you run commands directly from your terminal. This improves your local development experience since it makes it easier to run exactly what you need, when you need it."]
    }), "\n", _jsxs(_components.p, {
      children: ["此外，全局 ", _jsx(_components.code, {
        children: "turbo"
      }), " 在你的 CI 流水线中非常有用，它可以让你最大限度地控制在流水线的每个点上要运行哪些任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Additionally, global ", _jsx(_components.code, {
        children: "turbo"
      }), " is useful in your CI pipelines, giving you maximum control of exactly which tasks to run at each point in your pipeline."]
    }), "\n", _jsx(_components.h3, {
      id: "自动确定软件包作用域-automatic-package-scoping",
      children: "自动确定软件包作用域 "
    }), "\n", _jsx(_components.p, {
      children: "¥Automatic Package Scoping"
    }), "\n", _jsxs(_components.p, {
      children: ["当你在某个包的目录中时，", _jsx(_components.code, {
        children: "turbo"
      }), " 会自动将命令范围限定在该包的 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "软件包图表"
      }), " 上。这意味着你可以快速编写命令，而无需对包进行 ", _jsx(_components.a, {
        href: "/docs/reference/run#--filter-string",
        children: "编写过滤器"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When you're in a package's directory, ", _jsx(_components.code, {
        children: "turbo"
      }), " will automatically scope commands to the ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "Package Graph"
      }), " for that package. This means you can quickly write commands without having to ", _jsx(_components.a, {
        href: "/docs/reference/run#--filter-string",
        children: "write filters"
      }), " for the package."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "cd"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " apps/docs"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["在上面的示例中，", _jsx(_components.code, {
        children: "turbo build"
      }), " 命令将使用在 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中注册的 ", _jsx(_components.code, {
        children: "build"
      }), " 任务为 ", _jsx(_components.code, {
        children: "docs"
      }), " 包运行 ", _jsx(_components.code, {
        children: "build"
      }), " 任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In the example above, the ", _jsx(_components.code, {
        children: "turbo build"
      }), " command will run the ", _jsx(_components.code, {
        children: "build"
      }), " task for the ", _jsx(_components.code, {
        children: "docs"
      }), " package using the ", _jsx(_components.code, {
        children: "build"
      }), " task registered in ", _jsx(_components.code, {
        children: "turbo.json"
      }), "."]
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.a, {
          href: "#using-filters",
          children: "使用过滤器"
        }), " 将覆盖自动包作用域。"]
      }), _jsxs(_components.p, {
        children: ["¥", _jsx(_components.a, {
          href: "#using-filters",
          children: "Using a filter"
        }), " will override Automatic Package Scoping."]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "自定义行为-customizing-behavior",
      children: "自定义行为 "
    }), "\n", _jsx(_components.p, {
      children: "¥Customizing behavior"
    }), "\n", _jsxs(_components.p, {
      children: ["在 ", _jsxs(_components.a, {
        href: "/docs/reference/run",
        children: [_jsx(_components.code, {
          children: "run"
        }), " 子命令文档"]
      }), " 中，你会发现许多有用的标志，可以根据你的需要定制 ", _jsx(_components.code, {
        children: "turbo run"
      }), " 的行为。运行全局 ", _jsx(_components.code, {
        children: "turbo"
      }), " 时，你可以使用以下工作流程加快速度："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In ", _jsxs(_components.a, {
        href: "/docs/reference/run",
        children: ["the documentation for the ", _jsx(_components.code, {
          children: "run"
        }), " subcommand"]
      }), ", you'll find many useful flags to tailor the behavior of ", _jsx(_components.code, {
        children: "turbo run"
      }), " for what you need. When running global ", _jsx(_components.code, {
        children: "turbo"
      }), ", you can go faster using workflows like:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["最常用命令的变体：", _jsx(_components.code, {
            children: "package.json"
          }), " 中的 ", _jsx(_components.code, {
            children: "build"
          }), " 脚本在 ", _jsx(_components.code, {
            children: "turbo build"
          }), " 中最为实用。 - 但你目前可能只对特定的软件包感兴趣。你可以使用 ", _jsx(_components.code, {
            children: "turbo build --filter=@repo/ui"
          }), " 快速筛选你感兴趣的特定包。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Variations of your most common commands"
          }), ": The ", _jsx(_components.code, {
            children: "build"
          }), " script in ", _jsx(_components.code, {
            children: "package.json"
          }), " has the most utility when it is ", _jsx(_components.code, {
            children: "turbo build"
          }), " - but you might only be interested in a specific package at the moment. You can quickly filter for the specific package you're interested in using ", _jsx(_components.code, {
            children: "turbo build --filter=@repo/ui"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["一次性命令：像 ", _jsx(_components.code, {
            children: "turbo build --dry"
          }), " 这样的命令并不常用，因此你可能不会在 ", _jsx(_components.code, {
            children: "package.json"
          }), " 中为其创建脚本。相反，你可以在需要时直接在终端中运行它。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "One-off commands"
          }), ": Commands like ", _jsx(_components.code, {
            children: "turbo build --dry"
          }), " aren't needed often so you likely won't create a script in your ", _jsx(_components.code, {
            children: "package.json"
          }), " for it. Instead, you can run it directly in your terminal whenever you need it."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["覆盖 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 配置：某些 CLI 参数在 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 中有等效项，你可以覆盖它们。例如，你可能已将 ", _jsx(_components.code, {
            children: "turbo build"
          }), " 命令配置为使用 ", _jsxs(_components.a, {
            href: "/docs/reference/configuration#outputlogs",
            children: [_jsx(_components.code, {
              children: "turbo.json"
            }), " 中的 ", _jsx(_components.code, {
              children: "\"outputLogs\": \"full\""
            })]
          }), "。 - 但你目前只想查看错误。使用全局 ", _jsx(_components.code, {
            children: "turbo"
          }), "，你可以使用 ", _jsx(_components.code, {
            children: "turbo lint --output-logs=errors-only"
          }), " 仅显示错误。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.strong, {
            children: ["Overriding ", _jsx(_components.code, {
              children: "turbo.json"
            }), " configuration"]
          }), ": Some CLI flags have an equivalent in ", _jsx(_components.code, {
            children: "turbo.json"
          }), " that you can override. For instance, you may have a ", _jsx(_components.code, {
            children: "turbo build"
          }), " command configured to use ", _jsxs(_components.a, {
            href: "/docs/reference/configuration#outputlogs",
            children: [_jsx(_components.code, {
              children: "\"outputLogs\": \"full\""
            }), " in ", _jsx(_components.code, {
              children: "turbo.json"
            })]
          }), " - but you're only interested in seeing errors at the moment. Using global ", _jsx(_components.code, {
            children: "turbo"
          }), ", you can use ", _jsx(_components.code, {
            children: "turbo lint --output-logs=errors-only"
          }), " to only show errors."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "运行多个任务-running-multiple-tasks",
      children: "运行多个任务 "
    }), "\n", _jsx(_components.p, {
      children: "¥Running multiple tasks"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), " 能够运行多个任务，并尽可能并行执行。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo"
      }), " is able to run multiple tasks, parallelizing whenever possible."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " check-types"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "此命令将运行所有任务，并根据你的任务定义自动检测可以尽早运行脚本的位置。"
    }), "\n", _jsx(_components.p, {
      children: "¥This command will run all of the tasks, automatically detecting where it can run a script as early as possible, according to your task definitions."
    }), "\n", _jsxs(Callout, {
      type: "info",
      title: "Ordering of tasks",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "turbo test lint"
        }), " 将运行与 ", _jsx(_components.code, {
          children: "turbo lint test"
        }), " 完全相同的任务。"]
      }), _jsxs(_components.p, {
        children: ["¥", _jsx(_components.code, {
          children: "turbo test lint"
        }), " will run tasks exactly the same as ", _jsx(_components.code, {
          children: "turbo lint test"
        }), "."]
      }), _jsxs(_components.p, {
        children: ["如果你想确保一个任务会阻止另一个任务的执行，请在你的 ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/configuring-tasks#defining-tasks",
          children: "任务配置"
        }), " 中表达这种关系。"]
      }), _jsxs(_components.p, {
        children: ["¥If you want to ensure that one task blocks the execution of another, express that relationship in your ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/configuring-tasks#defining-tasks",
          children: "task configurations"
        }), "."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "使用过滤器-using-filters",
      children: "使用过滤器 "
    }), "\n", _jsx(_components.p, {
      children: "¥Using filters"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks",
        children: "caching"
      }), " 确保你不会重复执行相同的工作，从而保持快速运行，你还可以过滤任务以仅运行 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "任务图"
      }), " 的子集。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥While ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks",
        children: "caching"
      }), " ensures you stay fast by never doing the same work twice, you can also filter tasks to run only a subset of ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "the Task Graph"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/reference/run#--filter-string",
        children: [_jsx(_components.code, {
          children: "--filter"
        }), " API 参考"]
      }), " 中有很多用于过滤的高级用例，但下面讨论的是最常见的用例。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥There are many advanced use cases for filtering in ", _jsxs(_components.a, {
        href: "/docs/reference/run#--filter-string",
        children: ["the ", _jsx(_components.code, {
          children: "--filter"
        }), " API reference"]
      }), " but the most common use cases are discussed below."]
    }), "\n", _jsx(_components.h3, {
      id: "按软件包过滤-filtering-by-package",
      children: "按软件包过滤 "
    }), "\n", _jsx(_components.p, {
      children: "¥Filtering by package"
    }), "\n", _jsx(_components.p, {
      children: "按包过滤是一种简单的方法，可以仅针对你当前正在处理的包运行任务。"
    }), "\n", _jsx(_components.p, {
      children: "¥Filtering by package is a simple way to only run tasks for the packages you're currently working on."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=@acme/web"
            })]
          })
        })
      })
    }), "\n", _jsxs(InVersion, {
      version: "2.2.4",
      children: [_jsxs(_components.p, {
        children: ["你也可以直接在 CLI 命令中筛选包的特定任务，而无需使用 ", _jsx(_components.code, {
          children: "--filter"
        }), "："]
      }), _jsxs(_components.p, {
        children: ["¥You can also filter to a specific task for the package directly in your CLI command without needing to use ", _jsx(_components.code, {
          children: "--filter"
        }), ":"]
      }), _jsx(_Fragment, {
        children: _jsx(_components.pre, {
          className: "shiki shiki-themes css-variables css-variables",
          style: {
            "--shiki-light": "var(--shiki-foreground)",
            "--shiki-dark": "var(--shiki-foreground)",
            "--shiki-light-bg": "var(--shiki-background)",
            "--shiki-dark-bg": "var(--shiki-background)"
          },
          tabIndex: "0",
          title: "Terminal",
          icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
          children: _jsxs(_components.code, {
            children: [_jsx(_components.span, {
              className: "line",
              children: _jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-comment)",
                  "--shiki-dark": "var(--shiki-token-comment)"
                },
                children: "# Run the `build` task for the `web` package"
              })
            }), "\n", _jsxs(_components.span, {
              className: "line",
              children: [_jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-function)",
                  "--shiki-dark": "var(--shiki-token-function)"
                },
                children: "turbo"
              }), _jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-string)",
                  "--shiki-dark": "var(--shiki-token-string)"
                },
                children: " run"
              }), _jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-string)",
                  "--shiki-dark": "var(--shiki-token-string)"
                },
                children: " web#build"
              })]
            }), "\n", _jsx(_components.span, {
              className: "line",
              children: " "
            }), "\n", _jsx(_components.span, {
              className: "line",
              children: _jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-comment)",
                  "--shiki-dark": "var(--shiki-token-comment)"
                },
                children: "# Run the `build` task for the `web` package, and the `lint` task for the `docs` package"
              })
            }), "\n", _jsxs(_components.span, {
              className: "line",
              children: [_jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-function)",
                  "--shiki-dark": "var(--shiki-token-function)"
                },
                children: "turbo"
              }), _jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-string)",
                  "--shiki-dark": "var(--shiki-token-string)"
                },
                children: " run"
              }), _jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-string)",
                  "--shiki-dark": "var(--shiki-token-string)"
                },
                children: " web#build"
              }), _jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-string)",
                  "--shiki-dark": "var(--shiki-token-string)"
                },
                children: " docs#lint"
              })]
            })]
          })
        })
      })]
    }), "\n", _jsx(_components.h3, {
      id: "按目录过滤-filtering-by-directory",
      children: "按目录过滤 "
    }), "\n", _jsx(_components.p, {
      children: "¥Filtering by directory"
    }), "\n", _jsxs(_components.p, {
      children: ["你的代码库可能具有一个目录结构，其中相关的包被分组在一起。在这种情况下，你可以捕获该目录的全局变量，以便将 ", _jsx(_components.code, {
        children: "turbo"
      }), " 集中在这些包上。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Your repository might have a directory structure where related packages are grouped together. In this case, you can capture the glob for that directory to focus ", _jsx(_components.code, {
        children: "turbo"
      }), " on those packages."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"./packages/utilities/*\""
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "过滤以包含依赖-filtering-to-include-dependents",
      children: "过滤以包含依赖 "
    }), "\n", _jsx(_components.p, {
      children: "¥Filtering to include dependents"
    }), "\n", _jsxs(_components.p, {
      children: ["当你处理特定包时，你可能需要为该包及其依赖运行任务。当你更改包并希望确保更改不会破坏其任何依赖时，", _jsx(_components.code, {
        children: "..."
      }), " 微语法非常有用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When you're working on a specific package, you might want to run tasks for the package and its dependents. The ", _jsx(_components.code, {
        children: "..."
      }), " microsyntax is useful when you're making changes to a package and want to ensure that the changes don't break any of its dependents."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=...ui"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "过滤以包含依赖-filtering-to-include-dependencies",
      children: "过滤以包含依赖 "
    }), "\n", _jsx(_components.p, {
      children: "¥Filtering to include dependencies"
    }), "\n", _jsxs(_components.p, {
      children: ["要将范围限制在某个包及其依赖，请在包名称后附加 ", _jsx(_components.code, {
        children: "..."
      }), "。这会为指定的包及其依赖的所有包运行任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To limit the scope to a package and its dependencies, append ", _jsx(_components.code, {
        children: "..."
      }), " to the package name. This runs the task for the specified package and all packages it depends on."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=web..."
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "按源代码控制更改过滤-filtering-by-source-control-changes",
      children: "按源代码控制更改过滤 "
    }), "\n", _jsx(_components.p, {
      children: "¥Filtering by source control changes"
    }), "\n", _jsxs(_components.p, {
      children: ["使用过滤器根据源代码控制中的更改运行任务，是仅针对受更改影响的包运行任务的好方法。源代码控制过滤器必须封装在 ", _jsx(_components.code, {
        children: "[]"
      }), " 中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Using filters to run tasks based on changes in source control is a great way to run tasks only for the packages that are affected by your changes. ", _jsxs(_components.strong, {
        children: ["Source control filters must be wrapped in ", _jsx(_components.code, {
          children: "[]"
        })]
      }), "."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["与上一个提交比较：", _jsx(_components.code, {
            children: "turbo build --filter=[HEAD^1]"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Comparing to the previous commit"
          }), ": ", _jsx(_components.code, {
            children: "turbo build --filter=[HEAD^1]"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["与主分支比较：", _jsx(_components.code, {
            children: "turbo build --filter=[main...my-feature]"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Comparing to the main branch"
          }), ": ", _jsx(_components.code, {
            children: "turbo build --filter=[main...my-feature]"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["使用 SHA 比较特定提交：", _jsx(_components.code, {
            children: "turbo build --filter=[a1b2c3d...e4f5g6h]"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Comparing specific commits using SHAs"
          }), ": ", _jsx(_components.code, {
            children: "turbo build --filter=[a1b2c3d...e4f5g6h]"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["使用分支名称比较特定提交：", _jsx(_components.code, {
            children: "turbo build --filter=[your-feature...my-feature]"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Comparing specific commits using branch names"
          }), ": ", _jsx(_components.code, {
            children: "turbo build --filter=[your-feature...my-feature]"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["通常，你可以依靠缓存来保持代码库的快速运行。当你使用 ", _jsx(_components.a, {
          href: "/docs/core-concepts/remote-caching",
          children: "远程缓存"
        }), " 时，你可以依靠未更改的包的缓存命中。"]
      }), _jsxs(_components.p, {
        children: ["¥In general, you can rely on caching to keep your repository fast. When you're\nusing ", _jsx(_components.a, {
          href: "/docs/core-concepts/remote-caching",
          children: "Remote Caching"
        }), ", you can count on\nhitting cache for unchanged packages."]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "合并过滤器-combining-filters",
      children: "合并过滤器 "
    }), "\n", _jsx(_components.p, {
      children: "¥Combining filters"
    }), "\n", _jsxs(_components.p, {
      children: ["为了更加明确，你可以组合使用过滤器来进一步优化 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "任务图"
      }), " 的入口点。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For even more specificity, you can combine filters to further refine the entrypoints into your ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "Task Graph"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=...ui"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "./packages/*}"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=[HEAD^1]"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["多个过滤器组合成一个联合体，这意味着 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "任务图"
      }), " 将包含与任意过滤器匹配的任务。更多有关过滤器高级用法的信息，请参阅 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--filter-string",
        children: [_jsx(_components.code, {
          children: "--filter"
        }), " API 参考"]
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Multiple filters are combined as a ", _jsx(_components.strong, {
        children: "union"
      }), ", meaning that the ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "Task Graph"
      }), " will include tasks that match any of the filters. For more information on advanced usage of filters, see ", _jsxs(_components.a, {
        href: "/docs/reference/run#--filter-string",
        children: ["the ", _jsx(_components.code, {
          children: "--filter"
        }), " API reference"]
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "后续步骤-next-steps",
      children: "后续步骤 "
    }), "\n", _jsx(_components.p, {
      children: "¥Next steps"
    }), "\n", _jsxs(_components.p, {
      children: ["当你开始在代码库中运行任务时，你可能会注意到任务速度变快了。接下来，你将探索 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "caching"
      }), " 以及 ", _jsx(_components.code, {
        children: "turbo"
      }), " 如何让你避免重复工作。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When you start running tasks in your repository, you might start noticing that your tasks get faster. Next, you'll explore ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "caching"
      }), " and how ", _jsx(_components.code, {
        children: "turbo"
      }), " makes it so you never do the same work twice."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
